  $(document).ready(function() {
    $('.blog-filter-by').click(function() {
    $('.BlogTagFilter').toggleClass('active-blog-filter');
  });
   var activeDivIndex = localStorage.getItem("activeDivIndex") || 0; 
    localStorage.setItem("activeDivIndex", activeDivIndex);
    $(".custom-blog-filter").eq(activeDivIndex).addClass("active_filter");
    $(".custom-blog-filter").click(function() {
        $(".custom-blog-filter").removeClass("active_filter");
        $(this).addClass("active_filter");
        var index = $(this).index();
        localStorage.setItem("activeDivIndex", index);
    });
    $('#custom-blogpost-search').on('keyup', function() {
      var searchText = $(this).val().toLowerCase();
      $('.blog-articles__article').each(function() {
        var articleTitle = $(this).find('.card__heading').text().toLowerCase();
        if (articleTitle.indexOf(searchText) === -1) {
          $(this).hide();
        } else {
          $(this).show();
        }
      });
    });
  });